<template>
  <div class="sidebarSearch">

    <ion-searchbar @ionChange="eventSearch" :placeholder="general.searchPlaceholder" ></ion-searchbar>

    <div class="wrapper">
      <div class="wrapper-buttons" v-if="options">
        <div class="select__wrapper" style="width:100%!important">
          <font-awesome-icon :icon="['far', 'chevron-down']" />
          <b-form-select v-model="selected" :options="options.options" class="select">
          </b-form-select>
        </div>

<!--        <b-button class="btn bt-white" v-b-toggle="'collapse-filter'">-->
<!--          <span><font-awesome-icon :icon="['fas', 'sliders-h']" /></span>-->
<!--          <span>{{general.filter}}</span>-->
<!--        </b-button>-->
      </div>

      <b-collapse id="collapse-filter" class="mt-2" v-if="options">
        <b-form-group label="Filtres">
          <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="selectFilter"
                  :options="options.filters"
                  switches
          ></b-form-checkbox-group>
        </b-form-group>
        <b-button class='btn btn-white' v-b-toggle="'collapse-filter'">{{general.formBtApply}}</b-button>
      </b-collapse>


      <!-- <ion-list> -->
      <b-list-group style="height:70vh;overflow: scroll;">
        <PuSkeleton :loading="isLoading" :count="5" width='100%' height="50px">
        </PuSkeleton>
        <div v-if="!isLoading">
          <b-list-group-item  v-for="(commercial,i) in filteredList" :key="`${i}`">
            <b-button class="btn-listSearch" @click="onItemClick(commercial)">
              <!-- <router-link :to="{ name: 'commercial', params: { userId: commercial.id }}" class="btn-listSearch" > -->
              <div class="title"><PuSkeleton>{{commercial.fullName}}</PuSkeleton></div>
              <div class="right d-none" :class="commercial.progression === '+' ? 'positif' : 'negatif'">
                    <span>
                      <PuSkeleton circle height="50px">
                        <font-awesome-icon v-if="commercial.progression === '+'" :icon="['far', 'chart-line']" />
                        <font-awesome-icon v-else :icon="['far', 'chart-line-down']" />
                      </PuSkeleton>
                    </span>
                <PuSkeleton><div class="number">{{Math.round(commercial.number)}}%</div></PuSkeleton>
              </div>
              <!-- </router-link>            -->
            </b-button>
          </b-list-group-item>
        </div>
      </b-list-group>
      <!-- </ion-list> -->

    </div>

  </div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import ApiAuthenticationService from "../../../services/ApiAuthenticationService";
  import ApiService from '../../../services/ApiService'

  export default {
    name: "SidebarSearch",

    components: {
    },

    data() {
      return {
        search: '',
        general:[],
        selectFilter: [],
        selected: null,
        isMobile:false,
        options: null,
        isLoading:true,
        userList:[]
      }
    },
    computed: {
      ...mapGetters([
        'getGeneral',
        'getRcrSideSearch',
        'getNationalSideSearch',
          'getIsMobile'
      ]),
      filteredList() {
        if(this.userList.length > 0){
          return this.userList.filter(commercial => {
            return commercial.fullName.toLowerCase().includes(this.search.toLowerCase())
          })
        } else {
          return [];
        }
      }
    },
    created (){
      this.general= this.getGeneral;
      if(ApiAuthenticationService.getCurrentUser().type == 'CONFIG_RCR' || ApiAuthenticationService.getCurrentUser().type == 'CONFIG_ASSISTANTE'){
        this.options = this.getRcrSideSearch;
        this.selected = this.options.options[0].value;
      } else if(ApiAuthenticationService.getCurrentUser().type == 'CONFIG_NATIONAL'){
        this.options= this.getNationalSideSearch;
        this.selected = this.options.options[0].value;
      }
      this.isMobile = this.getIsMobile;
      this.getData().then(() => this.isLoading = false);
    },
    methods: {
      eventSearch : function(event){
        this.search = event.target.value;
      },
      onItemClick(target) {
        this.$router.push({ name: 'commercial', params: { userId: target.id}});
        this.isMobile ? setTimeout(()=> {this.$store.dispatch('showHeader',false);},50):'';
      },
      async getData(){
        this.isLoading = true;
        await ApiService.getCommercialApi().getCommercialsList(ApiAuthenticationService.getCurrentUser().id, this.selected).then((data) => {
          this.userList = data.data;
        });

      }
    },
    watch: {
      'selected' : function() {
        this.getData().then(() => this.isLoading = false);
      },
      getIsMobile(){
        this.isMobile = this.getIsMobile;
      }
    }
  }
</script>
